import React from 'react'
import DropdownField from 'pf9-ui-components/built/components/validatedForm/DropdownField'
import TextField from 'pf9-ui-components/built/components/validatedForm/TextField'
import VolumeTypesPicklist from 'app/plugins/openstack/components/storage/volume-types/VolumeTypesPicklist'
import ClusterVMSourceType from './ClusterVMSourceType'
import { volumeSizeValidator } from 'core/utils/fieldValidators'

interface SourcePoolFieldsProps {
  getParamsUpdater: (key: string) => (value: any) => void
  params: Record<string, any>
}

const SourcePoolFields = ({ params, getParamsUpdater }: SourcePoolFieldsProps) => {
  return (
    <>
      <DropdownField
        id="clusterVmSourceType"
        DropdownComponent={ClusterVMSourceType}
        label="Boot VM From"
        onChange={(value) => getParamsUpdater('sourceType')(value)}
        value={params.sourceType}
        required
      />
      {params.sourceType === 'volume' && (
        <>
          <TextField
            id="clusterVmVolumeSize"
            label="Volume Size (GiB)"
            onChange={(value) => getParamsUpdater('volumeSize')(value)}
            value={params.volumeSize}
            type="number"
            validations={[volumeSizeValidator(20)]}
            min={20}
            info="Volume size should be equivalent to virtual disk size of an image or more"
            required
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
            crossOrigin={undefined}
          />
          <DropdownField
            id="clusterVmVolumeType"
            fullWidth
            DropdownComponent={VolumeTypesPicklist}
            value={params.volumeType}
            onChange={getParamsUpdater('volumeType')}
            label="Volume Type"
            required
          />
        </>
      )}
    </>
  )
}

export default SourcePoolFields
